var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTripMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.671875 3.50127C0.671875 3.10345 0.82991 2.72192 1.11121 2.44061C1.39252 2.15931 1.77405 2.00127 2.17188 2.00127H8.17188C8.5697 2.00127 8.95123 2.15931 9.23254 2.44061C9.51384 2.72192 9.67188 3.10345 9.67188 3.50127V13.1693C9.67183 13.2571 9.64863 13.3435 9.60461 13.4195C9.56058 13.4956 9.49729 13.5587 9.4211 13.6025C9.34492 13.6463 9.25854 13.6692 9.17066 13.669C9.08278 13.6688 8.99651 13.6454 8.92054 13.6013L5.17188 11.4146L1.42387 13.6013C1.34789 13.6456 1.26155 13.6691 1.17357 13.6694C1.0856 13.6697 0.999098 13.6468 0.922813 13.603C0.846528 13.5591 0.783156 13.496 0.739096 13.4198C0.695036 13.3437 0.671849 13.2572 0.671875 13.1693V3.50127ZM8.17188 0.335938C9.01173 0.335938 9.81718 0.669567 10.411 1.26343C11.0049 1.8573 11.3385 2.66275 11.3385 3.5026V11.4179C11.3385 11.5505 11.2859 11.6777 11.1921 11.7715C11.0983 11.8653 10.9712 11.9179 10.8385 11.9179C10.7059 11.9179 10.5788 11.8653 10.485 11.7715C10.3912 11.6777 10.3385 11.5505 10.3385 11.4179V3.50327C10.3385 2.92864 10.1103 2.37753 9.70394 1.97121C9.29761 1.56488 8.74651 1.3366 8.17188 1.3366H2.42988C2.42988 1.3366 2.50521 0.964604 2.96121 0.615271C3.33854 0.335937 3.73988 0.335938 3.73988 0.335938H8.17188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTripMobile);
export default __webpack_public_path__ + "static/media/MyTripMobile.ef1afbf790d1cd0f272196ec9200febe.svg";
export { ForwardRef as ReactComponent };